import { SEPARATOR, exactValidator, genericValidateName, uuidValidator } from './genericName';
export const prefix = 'habitats';
export const prefixWithSeparator = 'habitats' + SEPARATOR;
export const IDToName = ({ habitatID }) => {
    return prefixWithSeparator + habitatID;
};
export const validateName = genericValidateName([exactValidator(prefix), uuidValidator()]);
export const nameToID = (name) => {
    validateName(name); // throws if invalid
    const parts = name.split('/');
    return {
        habitatID: parts[1],
    };
};
